import {PlayerStatType} from "../../PlayerStats/definition";
import {TeamStatType} from "../../TeamStats/definition";
import {EventFilterCondition} from "../../../types";

export const createStatTypeConditions = (statType: TeamStatType | PlayerStatType): EventFilterCondition[] => {
	const conditions: EventFilterCondition[] = [];

	switch (statType) {
		case PlayerStatType.AerialDuel:
		case PlayerStatType.AerialDuelSuccess:
		case TeamStatType.AerialDuel:
			conditions.push({ type: "type", value: ["aerial_duel"] });
			break;
		case PlayerStatType.Assist:
			conditions.push({ type: "flag", flag: "assist", value: ["true"] });
			break;
		case PlayerStatType.Block:
		case TeamStatType.Block:
			conditions.push({ type: "type", value: ["block"] });
			break;
		case PlayerStatType.BlockAndParry:
			conditions.push({ type: "type", value: ["save"] });
			conditions.push({ type: "flag", flag: "save_type", value: ["parry", "block"] });
			break;
		case PlayerStatType.CardYellow:
			conditions.push({ type: "type", value: ["card"] });
			conditions.push({ type: "flag", flag: "card_type", value: ["yellow"] });
			break;
		case PlayerStatType.CardRed:
			conditions.push({ type: "type", value: ["card"] });
			conditions.push({ type: "flag", flag: "card_type", value: ["red"] });
			break;
		case PlayerStatType.Catch:
			conditions.push({ type: "type", value: ["save"] });
			conditions.push({ type: "flag", flag: "save_type", value: ["catch"] });
			break;
		case PlayerStatType.CatchInterception:
		case PlayerStatType.CatchInterceptionSuccess:
			conditions.push({ type: "type", value: ["catch_interception"] });
			break;
		case TeamStatType.Clearance:
			conditions.push({ type: "type", value: ["clearance"] });
			break;
		case PlayerStatType.Corner:
		case TeamStatType.Corner:
			conditions.push({ type: "type", value: ["shot", "pass"] });
			conditions.push({ type: "flag", flag: "restart", value: ["corner-kick"] });
			break;
		case PlayerStatType.Cross:
		case PlayerStatType.CrossSuccess:
		case TeamStatType.Cross:
		case TeamStatType.CrossSuccess:
			conditions.push({ type: "type", value: ["pass"] });
			conditions.push({ type: "flag", flag: "cross", value: ["true"] });
			break;
		case TeamStatType.Foul:
		case PlayerStatType.Foul:
		case PlayerStatType.FoulCommited:
			conditions.push({ type: "type", value: ["foul"] });
			conditions.push({ type: "flag", flag: "foul_type", value: ["committed"] });
			break;
		case PlayerStatType.FoulWon:
		case TeamStatType.FoulWon:
			conditions.push({ type: "type", value: ["foul"] });
			conditions.push({ type: "flag", flag: "foul_type", value: ["won"] });
			break;
		case PlayerStatType.FreeKick:
		case TeamStatType.FreeKick:
			conditions.push({ type: "type", value: ["shot", "pass"] });
			conditions.push({ type: "flag", flag: "restart", value: ["free-kick"] });
			break;
		case TeamStatType.Goal:
		case PlayerStatType.Goal:
			conditions.push({ type: "type", value: ["goal"] });
			break;
		case PlayerStatType.GoalConceded:
			conditions.push({ type: "type", value: ["goal_conceded"] });
			break;
		case TeamStatType.GoalOwn:
			conditions.push({ type: "type", value: ["own_goal"] });
			break;
		case PlayerStatType.GoalKick:
		case PlayerStatType.GoalKickSuccess:
			conditions.push({ type: "type", value: ["pass"] });
			conditions.push({ type: "flag", flag: "restart", value: ["goal-kick"] });
			break;
		case PlayerStatType.GoalOwn:
			conditions.push({ type: "type", value: ["own_goal"] });
			break;
		case PlayerStatType.GroundDuel:
		case PlayerStatType.GroundDuelSuccess:
			conditions.push({ type: "type", value: ["take_on", "take_on_against", "tackle"] });
			break;
		case PlayerStatType.Interception:
		case TeamStatType.Interception:
			conditions.push({ type: "type", value: ["interception"] });
			break;
		case PlayerStatType.KeyPass:
		case TeamStatType.KeyPass:
			conditions.push({ type: "type", value: ["pass"] });
			conditions.push({ type: "flag", flag: "key_pass", value: ["true"] });
			break;
		case TeamStatType.Mistake:
			conditions.push({ type: "type", value: ["technical_error"] });
			break;
		case PlayerStatType.Offside:
		case TeamStatType.Offside:
			conditions.push({ type: "type", value: ["offside"] });
			break;
		case PlayerStatType.Pass:
		case PlayerStatType.PassSuccess:
		case TeamStatType.Pass:
		case TeamStatType.PassSuccess:
			conditions.push({ type: "type", value: ["pass"] });
			break;
		case PlayerStatType.PassBackward:
		case PlayerStatType.PassBackwardSuccess:
		case TeamStatType.PassBackward:
		case TeamStatType.PassBackwardSuccess:
			conditions.push({ type: "type", value: ["pass"] });
			conditions.push({ type: "flag", flag: "direction", value: ["backward"] });
			break;
		case PlayerStatType.PassForward:
		case PlayerStatType.PassForwardSuccess:
		case TeamStatType.PassForward:
		case TeamStatType.PassForwardSuccess:
			conditions.push({ type: "type", value: ["pass"] });
			conditions.push({ type: "flag", flag: "direction", value: ["forward"] });
			break;
		case PlayerStatType.PassInDefensiveThird:
		case PlayerStatType.PassInDefensiveThirdSuccess:
		case TeamStatType.PassInDefensiveThird:
		case TeamStatType.PassInDefensiveThirdSuccess:
			conditions.push({ type: "type", value: ["pass"] });
			conditions.push({ type: "flag", flag: "third", value: ["defensive"] });
			break;
		case PlayerStatType.PassInFinalThird:
		case PlayerStatType.PassInFinalThirdSuccess:
		case TeamStatType.PassInFinalThird:
		case TeamStatType.PassInFinalThirdSuccess:
			conditions.push({ type: "type", value: ["pass"] });
			conditions.push({ type: "flag", flag: "third", value: ["final"] });
			break;
		case PlayerStatType.PassInMiddleThird:
		case PlayerStatType.PassInMiddleThirdSuccess:
		case TeamStatType.PassInMiddleThird:
		case TeamStatType.PassInMiddleThirdSuccess:
			conditions.push({ type: "type", value: ["pass"] });
			conditions.push({ type: "flag", flag: "third", value: ["middle"] });
			break;
		case PlayerStatType.PassLong:
		case PlayerStatType.PassLongSuccess:
		case TeamStatType.PassLong:
		case TeamStatType.PassLongSuccess:
			conditions.push({ type: "type", value: ["pass"] });
			conditions.push({ type: "flag", flag: "length", value: ["long"] });
			break;
		case PlayerStatType.PassMedium:
		case PlayerStatType.PassMediumSuccess:
		case TeamStatType.PassMedium:
		case TeamStatType.PassMediumSuccess:
			conditions.push({ type: "type", value: ["pass"] });
			conditions.push({ type: "flag", flag: "length", value: ["medium"] });
			break;
		case PlayerStatType.PassSideways:
		case PlayerStatType.PassSidewaysSuccess:
		case TeamStatType.PassSideways:
		case TeamStatType.PassSidewaysSuccess:
			conditions.push({ type: "type", value: ["pass"] });
			conditions.push({ type: "flag", flag: "direction", value: ["sideways"] });
			break;
		case PlayerStatType.PassShort:
		case PlayerStatType.PassShortSuccess:
		case TeamStatType.PassShort:
		case TeamStatType.PassShortSuccess:
			conditions.push({ type: "type", value: ["pass"] });
			conditions.push({ type: "flag", flag: "length", value: ["short"] });
			break;
		case PlayerStatType.Punch:
			conditions.push({ type: "type", value: ["punch"] });
			break;
		case PlayerStatType.Recovery:
		case TeamStatType.Recovery:
		case PlayerStatType.LoseBallRecovery:
			conditions.push({ type: "type", value: ["recovery"] });
			break;
		case PlayerStatType.Shot:
			conditions.push({ type: "type", value: ["shot"] });
			break;
		case PlayerStatType.ShotOffTarget:
		case TeamStatType.ShotOffTarget:
			conditions.push({ type: "type", value: ["shot"] });
			conditions.push({ type: "flag", flag: "on_target", value: ["off"] });
			break;
		case PlayerStatType.ShotInsidePa:
		case TeamStatType.ShotInsidePa:
			conditions.push({ type: "type", value: ["shot"] });
			conditions.push({ type: "flag", flag: "inside_pa", value: ["true"] });
			break;
		case PlayerStatType.ShotOnTarget:
		case TeamStatType.ShotOnTarget:
			conditions.push({ type: "type", value: ["shot"] });
			conditions.push({ type: "flag", flag: "on_target", value: ["on"] });
			break;
		case PlayerStatType.ShotOutsidePa:
		case TeamStatType.ShotOutsidePa:
			conditions.push({ type: "type", value: ["shot"] });
			conditions.push({ type: "flag", flag: "inside_pa", value: ["false"] });
			break;
		case PlayerStatType.ShotBlocked:
		case TeamStatType.ShotBlocked:
			conditions.push({ type: "type", value: ["shot"] });
			conditions.push({ type: "flag", flag: "on_target", value: ["blocked"] });
			break;
		case PlayerStatType.Tackle:
		case PlayerStatType.TackleSuccess:
		case TeamStatType.Tackle:
		case TeamStatType.TackleSuccess:
			conditions.push({ type: "type", value: ["tackle"] });
			break;
		case PlayerStatType.TakeOn:
		case PlayerStatType.TakeOnSuccess:
		case TeamStatType.TakeOn:
		case TeamStatType.TakeOnSuccess:
			conditions.push({ type: "type", value: ["take_on"] });
			break;
		case PlayerStatType.ThrowIn:
			conditions.push({ type: "type", value: ["shot", "pass"] });
			conditions.push({ type: "flag", flag: "restart", value: ["throw-in"] });
		case PlayerStatType.PassReceived:
			conditions.push({ type: "type", value: ["pass_received"] });
			break;
		case PlayerStatType.Save:
			conditions.push({ type: "type", value: ["save"] });
			break;
		case PlayerStatType.TakeOnAgainst:
			conditions.push({ type: "type", value: ["defensive_1on1"] });
			break;
		case PlayerStatType.TechnicalError:
			conditions.push({ type: "type", value: ["technical_error"] });
			break;
	}

	if (conditions.length !== 0 && statType.endsWith("Success")) {
		conditions.push({ type: "success", value: ["true"] });
	}

	return conditions;
}
